import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getTemporaryTwoFaUserTokenExpiresAt } from '../store';
export var useTwoFaCheckTimeout = function (_a) {
    var onTempUserTokenExpired = _a.onTempUserTokenExpired;
    var twoFaTokenExpiresAt = useSelector(getTemporaryTwoFaUserTokenExpiresAt);
    useEffect(function () {
        var timer;
        if (twoFaTokenExpiresAt) {
            var now = new Date();
            var tokenExpiresIn = Math.max(twoFaTokenExpiresAt.getTime() - now.getTime(), 0);
            timer = setTimeout(function () {
                onTempUserTokenExpired();
            }, tokenExpiresIn);
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [twoFaTokenExpiresAt]);
};
